import { Platform } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';

export const getBottomSafeAreaPadding = (): number => {
  if (Platform.OS === 'ios') {
    return 34; // Standard iOS bottom safe area
  }
  return 16; // Standard Android bottom padding
};

export const useBottomSafeAreaPadding = (): number => {
  const insets = useSafeAreaInsets();
  return insets.bottom > 0 ? insets.bottom + 16 : 16;
};

export const getBottomButtonStyle = () => ({
  paddingBottom: getBottomSafeAreaPadding(),
});
